import React, { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ReCAPTCHA from "react-google-recaptcha"
import moment from 'moment'

import './InputReservationReferencePage.css'

import { getReservation } from '../../services/GetReservation'
import { getCountries } from '../../services/GetCountries'
import { getGroupsDetails } from '../../services/GetGroupsDetails'
import { validateGoogleCaptcha } from '../../services/ValidateGoogleCaptcha'
import { getStationsConfigurations } from '../../services/Stations'
import { verifyReservationWithRA } from '../review-rental-agreement/api'

import { GroupsImagesContext } from '../../domain-repository/GroupsImagesRepository'
import { DomainContext } from '../../domain-repository/DomainRepository'

import Loading from '../../components/Loading'
import Footer from '../../components/Footer'
import withLang from '../../withLang'
import { getBlockedTaxNumbers } from '../../services/ValidateTaxNumber'
import { saveSessionEnd } from '../../services/Metrics'
import { session } from '../../load-config'

function invalidSearchReferences(reference) {
  if (reference.toUpperCase().startsWith('DC-')) {
    return 'insertConfirmationNumberAlert'
  }
  return null
}

function InputReservationReferencePage(props) {
  const { t } = useTranslation()

  const { getSetGroupsConfigurations } = useContext(GroupsImagesContext)
  const {
    setReservation,
    setCountries,
    setDriverInfo,
    language,
    setAppFlowConfigs,
    appVersionId,
    setSessionId,
    setGroupsDetails,
    pickupDate,
    kioskCurrentStationId,
    setBlockedTaxNumbersList,
    setStationsConfigurations,
    setAdditionalDriverInfo,
  } = useContext(DomainContext);

  useEffect(() => {
    async function func() {
      if (session.getSessionId()) {
        await saveSessionEnd()
        setSessionId(null)
      }
    }

    func()
  }, [])

  const [resReference, setResReference] = useState('')
  const [googleCaptchaResult, setGoogleCaptchaResult] = useState(process.env.REACT_APP_GOOGLE_RECAPTCHA_DISABLE === 'TRUE' ? { isValid: true } : null)
  const [isLoading, setIsLoading] = useState(false)

  function handleResReferenceChange(event) { setResReference(event.target.value) }

  function onCaptchaChange(value) {
    if (!value) { return }
    validateGoogleCaptcha(value)
      .then(res => {
        if (!res.success) {
          // reset captcha?
        }
        setGoogleCaptchaResult({ isValid: res.success })
      })
      .catch(err => {
        console.log(err)
        setGoogleCaptchaResult({ isValid: false })
        // reset captcha?
      })
  }

  function onCaptchaExpire() {
    setGoogleCaptchaResult(null)
  }

  function onCaptchaError() {
    // setGoogleCaptchaResult(null)
  }

  function handleNextClick(e) {
    if (e) {
      e.preventDefault()
    }
    if (!resReference || !kioskCurrentStationId || !pickupDate || !googleCaptchaResult || !googleCaptchaResult.isValid) { return }

    setIsLoading(true)
    getReservationFromReference()
  }

  async function getReservationFromReference() {
    setIsLoading(true)

    let formatedResNumberOrRefMatches = resReference.match(/(.*)count$/i)

    const groupConfig = await getSetGroupsConfigurations()

    const blockedTaxNumbersList = await getBlockedTaxNumbers()
    setBlockedTaxNumbersList(blockedTaxNumbersList.blockedTaxNumbers)

    Promise.all([
      getReservation({ resNumberOrReference: formatedResNumberOrRefMatches && formatedResNumberOrRefMatches.length > 1 ? formatedResNumberOrRefMatches[1] : resReference, stationId: kioskCurrentStationId, resCheckOutDate: pickupDate, appVersionId, language }),
      getCountries(),
      getGroupsDetails(Object.keys(groupConfig)),
      getStationsConfigurations(),
    ])
      .then(([reservation, countries, groups, stationsConfigurationsRes]) => {
        setIsLoading(false)

        if (!reservation || !countries || !groups || groups.length === 0) {
          props.history.push(`/input-reservation-ref-error?resReference=${resReference}`)
        } else {
          if (!reservation.redirectUrl) {
            setReservation(reservation)
            setDriverInfo(reservation.listReservation)
            setAdditionalDriverInfo(reservation.listReservation)
            setAppFlowConfigs(reservation.appFlowConfigs)
            setSessionId(reservation.sessionId)
          }
          setCountries(countries.map(c => ({ ...c, name: t(`country_${c.countryID}`) })))
          setGroupsDetails(groups.groupsDetails)
          setStationsConfigurations(stationsConfigurationsRes.stationsConfigurations)

          if (reservation.redirectUrl) {
           return props.history.push(reservation.redirectUrl)
          }
          props.history.push('/review-reservation');
        }
      })
      .catch(err => {
        setIsLoading(false)
        const errorMessage = err?.message || err || null
        props.history.push({ pathname: `/input-reservation-ref-error`, search: `resReference=${resReference}`, state: { errorMessage } })
      });
  }

  const searchAlert = invalidSearchReferences(resReference);

  return (
    <main className='page-layout'>
      <div className="container grow">
        <Loading active={isLoading} message={t('searchingReservation')} />
        <div className="row">
          <div className="col-3">
            <div onClick={() => props.history.push('/start')}>
              <img src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
            </div>
          </div>
        </div>
        <div className="main-frame">
          <div className="container">
            <div className="row justify-content-center">
              <form className="text-center" onSubmit={handleNextClick}>
                <label htmlFor="referencia" className="text-uppercase">{t('inputReservationMessageMobile1')}<b>{t('inputReservationMessageMobile2')}</b></label>
                <input autoComplete="off" name="referencia" type="text" className={`form-control text-center ${searchAlert ? 'error' : ''}`} value={resReference} onChange={handleResReferenceChange} />
                {searchAlert !== null &&
                  <div className='error-message'>
                    <p>{t(searchAlert)}</p>
                  </div>
                }
                <div className="recaptcha w-100 mt-3">
                  <ReCAPTCHA
                    hl={language}
                    sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}
                    onChange={onCaptchaChange}
                    onExpired={onCaptchaExpire}
                    onErrored={onCaptchaError}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer
        handlePrevClick={() => props.history.goBack()}
        nextDisabled={!resReference || !googleCaptchaResult || !googleCaptchaResult.isValid}
        handleNextClick={handleNextClick}
      />
    </main>
  )
}

export default withLang(InputReservationReferencePage)
